var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgListTree = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5H4.5V12H10.5V13.5H4.5V19.5H10.5V21H3.75C3.33579 21 3 20.6642 3 20.25V4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.25C16.5 19.8358 16.8358 19.5 17.25 19.5H21.75C22.1642 19.5 22.5 19.8358 22.5 20.25C22.5 20.6642 22.1642 21 21.75 21H17.25C16.8358 21 16.5 20.6642 16.5 20.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.75C16.5 12.3358 16.8358 12 17.25 12H21.75C22.1642 12 22.5 12.3358 22.5 12.75C22.5 13.1642 22.1642 13.5 21.75 13.5H17.25C16.8358 13.5 16.5 13.1642 16.5 12.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75C7.5 3.33579 7.83579 3 8.25 3H21.75C22.1642 3 22.5 3.33579 22.5 3.75C22.5 4.16421 22.1642 4.5 21.75 4.5H8.25C7.83579 4.5 7.5 4.16421 7.5 3.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18.75C15 18.3358 14.6642 18 14.25 18H11.25C10.8358 18 10.5 18.3358 10.5 18.75V21.75C10.5 22.1642 10.8358 22.5 11.25 22.5H14.25C14.6642 22.5 15 22.1642 15 21.75V18.75ZM13.5 19.5H12V21H13.5V19.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.25C15 10.8358 14.6642 10.5 14.25 10.5H11.25C10.8358 10.5 10.5 10.8358 10.5 11.25V14.25C10.5 14.6642 10.8358 15 11.25 15H14.25C14.6642 15 15 14.6642 15 14.25V11.25ZM13.5 12H12V13.5H13.5V12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.25C6 1.83579 5.66421 1.5 5.25 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V5.25C1.5 5.66421 1.83579 6 2.25 6H5.25C5.66421 6 6 5.66421 6 5.25V2.25ZM4.5 3H3V4.5H4.5V3Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListTree);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-tree.e1683557fa8e18a179098a7f00a099b8.svg";